import { ArrowRight } from "iconoir-react";

import { CtaButton } from "@/components/ui/cta-button";
import { cn } from "@/lib/utils";

import type { LinkProps } from "./link";
import { Link } from "./link";

/** @deprecated Use `ctaButtonVariants` from `@/components/ui/cta-button`. */
export const arrowPillLinkClassName =
  "inline-flex items-center gap-3 rounded-full py-1.5 pr-[7px] pl-4 text-ds-label-lg font-medium transition-[transform,background-color,opacity] duration-[180ms] active:scale-[0.97]";

export interface ArrowPillLinkProps extends LinkProps {
  variant?: "pulse" | "white";
}

export function ArrowPillLink({
  className,
  variant = "pulse",
  children,
  ...props
}: ArrowPillLinkProps) {
  return (
    <CtaButton
      variant={variant}
      size="pill"
      className={className}
      render={<Link {...props} />}
    >
      {children}
    </CtaButton>
  );
}

export interface SecondaryArrowLinkProps extends LinkProps {
  tone?: "onDark" | "onLight";
}

/** Figma secondary arrow link — 14px label, 4px icon gap. */
export function SecondaryArrowLink({
  className,
  tone = "onDark",
  children,
  ...props
}: SecondaryArrowLinkProps) {
  return (
    <Link
      className={cn(
        "text-ds-label-lg inline-flex shrink-0 items-center gap-1 font-medium transition-colors",
        tone === "onDark"
          ? "text-grey-0 hover:text-grey-0/90"
          : "text-grey-950 hover:text-grey-700",
        className
      )}
      {...props}
    >
      {children}
      <ArrowRight aria-hidden className="size-4" />
    </Link>
  );
}
